import { render, staticRenderFns } from "./BsSwitch.vue?vue&type=template&id=62c179ac&"
import script from "./BsSwitch.vue?vue&type=script&lang=js&"
export * from "./BsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BsSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports